import { Notification, UserNotificationAPI } from '../types/notification.types';

const categoryToTypeMap: Record<string, Notification['type']> = {
	user_creation: 'info',
	shift_change: 'warning',
	approval: 'success',
	alert: 'error',
	schedule: 'info',
	onboarding: 'info',
	checklist: 'warning',
	broadcast: 'info',
};

const categoryToActionUrlMap: Record<string, string> = {
	user_creation: '/manager/onboarding',
	shift_change: '/manager/hyperscheduler',
	schedule: '/manager/hyperscheduler',
	onboarding: '/manager/onboarding',
	checklist: '/manager/checklist',
	broadcast: '/manager/broadcast',
	events: '/manager/events',
};

export const mapAPINotificationToNotification = (
	apiNotification: UserNotificationAPI
): Notification => {
	const category = apiNotification.category || 'info';
	const type = categoryToTypeMap[category] || 'info';
	const actionUrl = categoryToActionUrlMap[category];

	return {
		id: apiNotification.id || apiNotification['@id'] || '',
		title: apiNotification.subject || 'Notification',
		message: apiNotification.message,
		timestamp: apiNotification.createdAt
			? new Date(apiNotification.createdAt)
			: apiNotification.updatedAt
			? new Date(apiNotification.updatedAt)
			: new Date(),
		isRead: apiNotification.status !== 'pending',
		type,
		actionUrl,
		category,
	};
};

export const mapAPINotificationsToNotifications = (
	apiNotifications: UserNotificationAPI[]
): Notification[] => {
	return apiNotifications.map(mapAPINotificationToNotification);
};
